module.exports = __webpack_public_path__ + "static/img/app-4.6da3b3df.png";